import React from 'react';
import PropTypes from 'prop-types';

const Video = ({ url, onCloseClick }) => {
	return (
		<React.Fragment>
			<button type="button" className="modal__close" onClick={onCloseClick} />

			<div className="modal__video">
				<video autoPlay controls>
					<source src={url} type="video/mp4" />
				</video>
			</div>
		</React.Fragment>
	);
};

Video.defaultProps = {
	url: null,
	onCloseClick: () => {},
};

Video.propTypes = {
	url: PropTypes.string,
	onCloseClick: PropTypes.func,
};

export default Video;
